import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type StarSolidIconProps = Omit<BaseIconProps, 'children'>;

export const StarSolidIcon = ({ strokeWidth, hasLegacyStrokeStyles, ...props }: StarSolidIconProps) => (
  <BaseIcon
    hasLegacyStrokeStyles={hasLegacyStrokeStyles ?? true}
    width="17"
    height="17"
    viewBox="-1 -1 16 16"
    fill="none"
    strokeWidth={strokeWidth}
    {...props}
  >
    <path
      d="M7.00016 0.660156L9.06016 4.83349L13.6668 5.50282L10.3335 8.75216L11.1202 13.3402L7.00016 11.1748L2.88016 13.3402L3.66683 8.75216L0.333496 5.50282L4.94016 4.83349L7.00016 0.660156Z"
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
  </BaseIcon>
);

StarSolidIcon.displayName = 'StarSolidIcon';
